import { useTranslation } from 'react-i18next';
import { Icon, Typography } from '..';
import { IconFileAudit, IconStamp } from '../../icons';
import { formatDate, truncateText } from '../../imports/utils';

type AuditBottomCardProps = {
  item: any;
};

const AuditBottomCard = ({ item }: AuditBottomCardProps) => {
  const { t } = useTranslation(['audit']);

  const statusColor = (state: string) => {
    switch (state) {
      case 'pending':
        return 'warning';
      case 'completed':
        return 'success';
      case 'error':
        return 'error';
      default:
        return 'black';
    }
  };

  return (
    <>
      <div className="flex-column flex gap-2">
        {item.status === 'pending' && <Icon icon={IconFileAudit} size="lg" />}
        {item.status === 'completed' && <Icon icon={IconStamp} size="lg" />}
        <div className="flex cursor-pointer flex-col items-start overflow-hidden truncate ">
          <Typography size="body-medium-12">
            {truncateText(item.name, {
              maxLength: 20,
              rightChars: 0,
            })}
          </Typography>
          <div className="flex flex-row">
            <Typography size="body-regular-12" color={statusColor(item.status)}>
              {t(`status.${item.status}`)}
            </Typography>
            <Typography size="body-regular-12">&nbsp;-&nbsp;</Typography>
            <Typography size="body-regular-12" color="grey-400">
              {formatDate(item.date)}
            </Typography>
          </div>
        </div>
      </div>
    </>
  );
};
export default AuditBottomCard;
